import {
    FETCH_ERROR,
    FETCH_START,
    FETCH_SUCCESS,
    INIT_URL,
    ON_STOCK_BALANCE,
    ON_STOCK_BALANCE_UNCOUNTED,
    ON_TRANSACTION_TREND,
    ON_PENDING_INTENTS,
    ON_PENDING_CONSIGNMENTS,
    ON_REJECTED_INTENTS,
    ON_REJECTED_CONSIGNMENTS,
    ON_INCOMPLETE_TRANSACTIONS
  } from "../constants/ActionTypes";
  import {adminAPI} from 'util/Api';
  import {getUserDetails} from 'actions';

  export const getStockBalance = () => {
    //alert('Am here');
    let token = sessionStorage.getItem('token');
   
    const _data = {
       headers: {
           Authorization: `Bearer ${token}`,
       }
      // data: {}
    };
    
      return (dispatch) => {
        dispatch({type: FETCH_START});
        adminAPI.get('stockbalances?scc='+parseInt(getUserDetails().SCC_ID),_data
        ).then(({data}) => { 
         //alert('Am here success'+JSON.stringify(data));
          //console.log('Success Stock Balance',data); 
          let newData = [];
          let newDataUncounted = [];
          //[{"DENOMINATION":10000,"DENOMINATION_TYPE":"NOTES","AMOUNT":200000000,"COUNTED":0,"QUANTITY":20},
          //{"DENOMINATION":10000,"DENOMINATION_TYPE":"NOTES","AMOUNT":300000000,"COUNTED":1,"QUANTITY":30}]
          for (let index = 0; index < data.length; index++) {
            if(data[index].COUNTED === 1){
             newData.push({'y':data[index].AMOUNT,'label':data[index].DENOMINATION+' '+data[index].DENOMINATION_TYPE+' '+data[index].YEAR})
            }
            
            if(data[index].COUNTED === 0){
             newDataUncounted.push({'y':data[index].AMOUNT,'label':data[index].DENOMINATION+' '+data[index].DENOMINATION_TYPE+' '+data[index].YEAR})
            }               
          }
          data = newData;
          //alert('Am here success'+JSON.stringify(newDataUncounted));
         //  data = [
         //      {'y':500000000,'label':'2000 Notes S2020'},
         //      {'y':600000000,'label':'1000 Notes S2020'},
         //      {'y':200000000,'label':'5000 Notes S2020'},
         //      {'y':50000000,'label':'10000 Notes S2020'},
         //      {'y':70000000,'label':'500 Coins S2020'},
         //      {'y':250000000,'label':'200 Coins S2020'},
         //      {'y':750000000,'label':'100 Coins S2020'}
         //   ]         
        if (data.length || newDataUncounted.length) {
           //console.log("Fetched Balances: ", data);
          dispatch({type: FETCH_SUCCESS});
          // format data and store them for use..
          dispatch({type: ON_STOCK_BALANCE, payload: data});
          dispatch({type: ON_STOCK_BALANCE_UNCOUNTED, payload: newDataUncounted});
        }else {
          dispatch({type: FETCH_ERROR, payload: data.error});
        }
      }).catch(function (error) {
       //alert('Am here error');
        //console.log('Not executing this one', error); 
        dispatch({type: FETCH_ERROR, payload: error.message});
        //console.log("Error****:", error.message);
      });
      }
    
     
   }

  export const getIncompleteTransactions = (sccFilter) => {
    //alert('Am here '+sccFilter);
    let token = sessionStorage.getItem('token');
   
    const _data = {
       headers: {
           Authorization: `Bearer ${token}`,
       }
      // data: {}
    };

    let uriX = 'incompleteRequests?scc='+(sccFilter == null ? parseInt(getUserDetails().SCC_ID) : sccFilter);
        
    
    
      return (dispatch) => {
        dispatch({type: FETCH_START});
        adminAPI.get(uriX,_data
        ).then(({data}) => { 
                
        if (data.length) {
           //console.log("Fetched Balances: ", data);
          dispatch({type: FETCH_SUCCESS});
          // format data and store them for use..
          dispatch({type: ON_INCOMPLETE_TRANSACTIONS, payload: data});
        }else {
          dispatch({type: FETCH_ERROR, payload: data.error});
        }
      }).catch(function (error) {
        // alert('Am here error '+uriX);
        // alert('Am here error '+uriX);
        //console.log('Not executing this one', error); 
        dispatch({type: FETCH_ERROR, payload: error.message});
        //console.log("Error****:", error.message);
      });
      }
    
     
   }

   export const getStockBalanceBySCC = (SCC_ID) => {
    //alert('IIII Am here '+SCC_ID);
    let token = sessionStorage.getItem('token');
   
    const _data = {
       headers: {
           Authorization: `Bearer ${token}`,
       }
      // data: {}
    };
     return async (dispatch) => {
         dispatch({type: FETCH_START});
         await adminAPI.get('stockbalances?scc='+SCC_ID,_data
         ).then(({data}) => { 
         // alert('Am here '+SCC_ID);
        //  alert('Am here success'+JSON.stringify(data));
           //console.log('Success Stock Balance',data); 
           let newData = [];
           let newDataUncounted = [];
           for (let index = 0; index < data.length; index++) {
             if(data[index].COUNTED === 1){
              newData.push({'y':data[index].AMOUNT,'label':data[index].DENOMINATION+' '+data[index].DENOMINATION_TYPE+' '+data[index].YEAR})
             }
             
             if(data[index].COUNTED === 0){
              newDataUncounted.push({'y':data[index].AMOUNT,'label':data[index].DENOMINATION+' '+data[index].DENOMINATION_TYPE+' '+data[index].YEAR})
             }               
           }
           data = newData;       
         if (data.length || newDataUncounted.length) {
            //console.log("Fetched Balances: ", data);
           dispatch({type: FETCH_SUCCESS});
           // format data and store them for use..
           dispatch({type: ON_STOCK_BALANCE, payload: data});
           dispatch({type: ON_STOCK_BALANCE_UNCOUNTED, payload: newDataUncounted});
         }else {
           dispatch({type: FETCH_ERROR, payload: data.error});
         }
       }).catch(function (error) {
        //alert('Am here error');
         //console.log('Not executing this one', error); 
         dispatch({type: FETCH_ERROR, payload: error.message});
         //console.log("Error****:", error.message);
       });
       }
   }

   export const getStockBalanceBySCCRepartriation = (SCC_ID) => {
    let token = sessionStorage.getItem('token');
   
    const _data = {
       headers: {
           Authorization: `Bearer ${token}`,
       }
      // data: {}
    };
     return async (dispatch) => {
         dispatch({type: FETCH_START});
         await adminAPI.get('stockbalances?scc='+SCC_ID,_data
         ).then(({data}) => { 
                
         if (data.length) {
            dispatch({type: FETCH_SUCCESS});
           dispatch({type: ON_STOCK_BALANCE, payload: data});
         }else {
           dispatch({type: FETCH_ERROR, payload: data.error});
         }
       }).catch(function (error) {
         dispatch({type: FETCH_ERROR, payload: error.message});
         //console.log("Error****:", error.message);
       });
       }
   }

   export const getTransactionTrend = () => {
    //console.log('Am here');
    let token = sessionStorage.getItem('token');
   
    const _data = {
       headers: {
           Authorization: `Bearer ${token}`,
       }
      // data: {}
    };
     return (dispatch) => {
         dispatch({type: FETCH_START});
         adminAPI.get('transactiontrend?scc='+getUserDetails().SCC_ID,_data
         ).then(({data}) => { 
            //let nd = new Date('2020-05-01'); 
            //alert(nd)
            // [ { MONTHS: '2020-06', TRAN_TYPE: 'REPATRIATION', AMOUNT: 100000000 },
            //   { MONTHS: '2020-06', TRAN_TYPE: 'REPLENISHMENT', AMOUNT: 11400000000 } ]

              let newDataReplenishments = [];   
              let newDataRepartriations = [];   
              let newDataWithDraws = [];   
              let newDataDeposits = [];   
              
            for (let index = 0; index < data.length; index++) {
              if(data[index].TRAN_TYPE == 'REPLENISHMENT'){
                newDataReplenishments.push({ x: new Date(data[index].MONTHS+'-01'), y: data[index].AMOUNT })
              }
              if(data[index].TRAN_TYPE == 'REPATRIATION'){
                newDataRepartriations.push({ x: new Date(data[index].MONTHS+'-01'), y: data[index].AMOUNT })
              }
              if(data[index].TRAN_TYPE == 'WITHDRAWS'){
                newDataWithDraws.push({ x: new Date(data[index].MONTHS+'-01'), y: data[index].AMOUNT })
              }
              if(data[index].TRAN_TYPE == 'DEPOSITS'){
                newDataDeposits.push({ x: new Date(data[index].MONTHS+'-01'), y: data[index].AMOUNT })
              }
            }

            //alert(JSON.stringify(newDataRepartriations))


             data = [
                 {
                    type:"spline",
                    axisYType: "secondary",
                    name: "Withdraws",
                    showInLegend: true,
                    markerSize: 0,
                    yValueFormatString: "#,###m",
                    dataPoints: newDataWithDraws
                 },{
                    type:"spline",
                    axisYType: "secondary",
                    name: "Deposits",
                    showInLegend: true,
                    markerSize: 0,
                    yValueFormatString: "#,###m",
                    dataPoints: newDataDeposits
                },{
                    type:"spline",
                    axisYType: "secondary",
                    name: "Replenishments",
                    showInLegend: true,
                    markerSize: 0,
                    yValueFormatString: "#,###m",
                    dataPoints: newDataReplenishments
                },{
                    type:"spline",
                    axisYType: "secondary",
                    name: "Repartriations",
                    showInLegend: true,
                    markerSize: 0,
                    yValueFormatString: "#,###m",
                    dataPoints: newDataRepartriations
                }
             ]
           //console.log('Success');          
         if (data.length) {
            //console.log("Fetched Trends: ", data);
           dispatch({type: FETCH_SUCCESS});
           // format data and store them for use..
           dispatch({type: ON_TRANSACTION_TREND, payload: data});
         } else {
           dispatch({type: FETCH_ERROR, payload: data.error});
         }
       }).catch(function (error) {
         //console.log('Not executing this one', error); 
         dispatch({type: FETCH_ERROR, payload: error.message});
         //console.log("Error****:", error.message);
       });
       }
   }

   export const getStockBalanceToHandover = () => {
    //alert('Am here');
    let token = sessionStorage.getItem('token');
   
    const _data = {
       headers: {
           Authorization: `Bearer ${token}`,
       }
      // data: {}
    };
     return (dispatch) => {
         dispatch({type: FETCH_START});
         adminAPI.get('stockbalances?scc='+getUserDetails().SCC_ID,_data
         ).then(({data}) => { 
          //alert('Am here success'+JSON.stringify(data));
           //console.log('Success Stock Balance',data); 
           let newData = [];
           let newDataUncounted = [];
           //[{"DENOMINATION":10000,"DENOMINATION_TYPE":"NOTES","AMOUNT":200000000,"COUNTED":0,"QUANTITY":20},
           //{"DENOMINATION":10000,"DENOMINATION_TYPE":"NOTES","AMOUNT":300000000,"COUNTED":1,"QUANTITY":30}]
           for (let index = 0; index < data.length; index++) {
             if(data[index].COUNTED === 1){
              newData.push(data[index])
             }
             
             if(data[index].COUNTED === 0){
              newDataUncounted.push(data[index])
             }               
           }
           data = newData;
         
         if (data.length || newDataUncounted.length) {
            //console.log("Fetched Balances: ", data);
            //alert('Am here success'+JSON.stringify(data));
           dispatch({type: FETCH_SUCCESS});
           // format data and store them for use..
           dispatch({type: ON_STOCK_BALANCE, payload: data});
           dispatch({type: ON_STOCK_BALANCE_UNCOUNTED, payload: newDataUncounted});
         }  else {
           dispatch({type: FETCH_ERROR, payload: data.error});
         }
       }).catch(function (error) {
        //alert('Am here error');
         //console.log('Not executing this one', error); 
         dispatch({type: FETCH_ERROR, payload: error.message});
         //console.log("Error****:", error.message);
       });
       }
   }


   export const getPendingIntents = () => {
    //console.log('Am here');
    let token = sessionStorage.getItem('token');
   
    const _data = {
       headers: {
           Authorization: `Bearer ${token}`,
       }
      // data: {}
    };
     return (dispatch) => {
         dispatch({type: FETCH_START});
         adminAPI.get('pendingintents?scc='+getUserDetails().SCC_ID,_data
         ).then(({data}) => { 
           //console.log('Success');          
         if (data.length) {
            //console.log("Fetched intents: ", data);
          let newData = [];
          let newDataRejected = [];
          for (let index = 0; index < data.length; index++) {
             if(data[index].STATUS != 'REJECTED'){
              newData.push(data[index]);
             };
             if(data[index].STATUS == 'REJECTED'){
              newDataRejected.push(data[index]);
             };
             
           }
           dispatch({type: FETCH_SUCCESS});
           // format data and store them for use..
           dispatch({type: ON_PENDING_INTENTS, payload: newData});
           dispatch({type: ON_REJECTED_INTENTS, payload: newDataRejected});
         } else {
           dispatch({type: FETCH_ERROR, payload: data.error});
         }
       }).catch(function (error) {
         //console.log('Not executing this one', error); 
         dispatch({type: FETCH_ERROR, payload: error.message});
         //console.log("Error****:", error.message);
       });
       }
   }

   export const getPendingConsignments = () => {
    //console.log('Am here');
    let token = sessionStorage.getItem('token');
   
    const _data = {
       headers: {
           Authorization: `Bearer ${token}`,
       }
      // data: {}
    };
     return (dispatch) => {
         dispatch({type: FETCH_START});
         adminAPI.get('pendingconsignments?scc='+getUserDetails().SCC_ID,_data
         ).then(({data}) => { 
           //console.log('Success');          
         if (data.length) {
           //console.log("Fetched consignments: ", data);
           let newData = [];
           let newDataRejected = [];
           for (let index = 0; index < data.length; index++) {
             if(data[index].STATUS != 'REJECTED'){
              newData.push(data[index]);
             };
             if(data[index].STATUS == 'REJECTED'){
              newDataRejected.push(data[index]);
             };
             
           }
           dispatch({type: FETCH_SUCCESS});
           // format data and store them for use..
           dispatch({type: ON_PENDING_CONSIGNMENTS, payload: newData});
           dispatch({type: ON_REJECTED_CONSIGNMENTS, payload: newDataRejected});
         } else {
           dispatch({type: FETCH_ERROR, payload: data.error});
         }
       }).catch(function (error) {
         //console.log('Not executing this one', error); 
         dispatch({type: FETCH_ERROR, payload: error.message});
         //console.log("Error****:", error.message);
       });
       }
   }